module.exports = __webpack_public_path__ + "img/ready.a0be6702.png";